export default function unsetGrabCursor() {
  var swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper.el.style.cursor = '';
}


//////////////////
// WEBPACK FOOTER
// /home/arkaitz/Proiektuak/mx-merkatari-elkartea/bedrock/web/app/themes/sage/node_modules/swiper/esm/components/core/grab-cursor/unsetGrabCursor.js
// module id = 58
// module chunks = 0